import React from 'react';
import './AmbassadorProgram.css';

const AmbassadorProgram = () => {
  return (
    <section className="static-page ambassador-program">
      <h1>MyApoti Ambassador Program</h1>
      <p>
        Are you passionate about improving access to healthcare in your community? The MyApoti Ambassador Program is your chance to be part of a growing movement that connects people with verified pharmacies and essential drugs — in real time.
      </p>
      <p>
        As an ambassador, you’ll help spread awareness about our platform, gather valuable user feedback, and support others in navigating the app when it launches.
      </p>

      <h3>Benefits of Becoming an Ambassador:</h3>
      <ul className="ambassador-benefits">
        <li>🌍 Make a positive impact in your community</li>
        <li>🎓 Gain valuable experience and leadership skills</li>
        <li>💬 Get early access to app features and insider updates</li>
        <li>🎁 Earn exclusive rewards and recognition</li>
      </ul>

      <div className="join-button-container">
        <a href="/AmbassadorRegister" className="join-button">Join Now</a>
      </div>
    </section>
  );
};

export default AmbassadorProgram;
